<template>
  <v-container fluid>
    <v-card class="pa-4">
      <!-- Header con botón Nuevo Grupo -->
      <div class="d-flex align-center mb-4">
        <v-icon color="#ce501b" size="large" class="mr-2">mdi-account-group</v-icon>
        <h2 class="text-h5">Gestión de Grupos</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="#ce501b"
          prepend-icon="mdi-plus"
          @click="abrirModalNuevoGrupo"
          elevation="2"
        >
          Nuevo Grupo
        </v-btn>
        <v-btn
          icon
          @click="recargarDesdeInicio"
          :loading="loading && grupos.length === 0"
          color="#ffe8e1"
          class="ml-2"
        >
          <v-icon color="#ce501b">mdi-refresh</v-icon>
        </v-btn>
      </div>

      <!-- Buscador -->
      <v-text-field
        ref="campoBusquedaRef"
        v-model="busqueda"
        prepend-inner-icon="mdi-magnify"
        label="Buscar grupo..."
        variant="outlined"
        density="comfortable"
        clearable
        class="mb-4"
        @input="filtrarGrupos"
      ></v-text-field>

      <!-- Tabla con infinite scroll -->
      <div 
        class="grupos-container" 
        @scroll="handleScroll"
        ref="scrollContainer"
      >
        <!-- Tabla -->
        <v-table class="grupos-table" fixed-header>
          <thead>
            <tr>
              <th class="text-center">Código</th>
              <th>Grupo</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(grupo, index) in gruposFiltrados"
              :key="index"
              class="grupo-row"
            >
              <!-- Código -->
              <td class="text-center">
                <v-chip color="primary" size="small" label>
                  {{ grupo.idGrupo }}
                </v-chip>
              </td>

              <!-- Nombre del Grupo -->
              <td>
                <div class="d-flex align-center">
                  <v-icon class="mr-2" size="small" color="blue-grey">mdi-account-group</v-icon>
                  <strong>{{ grupo.grupo }}</strong>
                </div>
              </td>

              <!-- Acciones -->
              <td class="text-center">
                <v-btn
                  icon
                  size="small"
                  color="green"
                  variant="text"
                  @click="verUsuarios(grupo)"
                  class="mr-1"
                >
                  <v-icon size="small">mdi-lock-open</v-icon>
                  <v-tooltip activator="parent" location="top">Ver Usuarios</v-tooltip>
                </v-btn>

                <v-btn
                  icon
                  size="small"
                  color="orange"
                  variant="text"
                  @click="editarGrupo(grupo)"
                  class="mr-1"
                >
                  <v-icon size="small">mdi-pencil</v-icon>
                  <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                </v-btn>

                <v-btn
                  icon
                  size="small"
                  color="red"
                  variant="text"
                  @click="confirmarEliminar(grupo)"
                >
                  <v-icon size="small">mdi-delete</v-icon>
                  <v-tooltip activator="parent" location="top">Eliminar</v-tooltip>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-table>

        <!-- Indicador de carga al final -->
        <div v-if="loading" class="text-center py-4">
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
          ></v-progress-circular>
          <p class="mt-2 text-caption">Cargando más grupos...</p>
        </div>

        <!-- Mensaje cuando no hay más datos -->
        <div v-if="!loading && !hayMasDatos && grupos.length > 0" class="text-center py-4 text-caption text-grey">
          <v-icon>mdi-check-circle</v-icon>
          No hay más grupos para mostrar
        </div>

        <!-- Mensaje cuando no hay datos -->
        <div v-if="!loading && grupos.length === 0" class="text-center py-8">
          <v-icon size="64" color="grey">mdi-account-group-outline</v-icon>
          <p class="text-h6 text-grey mt-2">No hay grupos registrados</p>
        </div>
      </div>
    </v-card>

    <!-- Modal Nuevo/Editar Grupo -->
    <v-dialog v-model="dialogNuevoGrupo" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
          {{ modoEdicion ? 'Editar Grupo' : 'Registro de Grupos' }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarModal"
            size="small"
            variant="text"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="formNuevoGrupo" v-model="validFormNuevo">
            <!-- Nombre del Grupo -->
            <v-text-field
              ref="campoGrupoRef"
              v-model="nuevoGrupo.grupo"
              label="Grupo"
              prepend-icon="mdi-account-group"
              variant="outlined"
              density="comfortable"
              :rules="[v => !!v || 'Nombre del grupo es requerido']"
              class="mb-3 campo-amarillo"
            
            ></v-text-field>

            <!-- Selector Jefe de Grupo -->
        <v-select
        v-model="nuevoGrupo.idJefe"
        :items="usuariosDisponibles"
        item-title="usuario"
        item-value="idUsuario"
        label="Jefe de grupo"
        prepend-icon="mdi-account-star"
        variant="outlined"
        density="comfortable"
        clearable
        placeholder="Seleccione..."
        :loading="loadingUsuarios"
        :return-object="false"
        class="mb-3"
      ></v-select>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
       <v-spacer></v-spacer>
          <v-btn
            color="#ce501b"
            variant="elevated"
            @click="guardarGrupo"
            :loading="guardando"
            :disabled="!validFormNuevo"
          >
            {{ modoEdicion ? 'Actualizar' : 'Grabar' }}
          </v-btn>

          <v-btn
            color="#9B9B9B"
            variant="elevated"
            @click="cerrarModal"
          >
            Cancelar
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Ver Usuarios del Grupo -->
    <v-dialog v-model="dialogVerUsuarios" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
          <v-icon class="mr-2">mdi-account-multiple</v-icon>
          Listado de usuarios
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarModalUsuarios"
            size="small"
            variant="text"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">
          <div v-if="grupoSeleccionado" class="mb-3">
            <v-chip color="primary" label size="small" class="mr-2">
              <v-icon start size="small">mdi-account-group</v-icon>
              {{ grupoSeleccionado.grupo }}
            </v-chip>
            <span class="text-caption text-grey" v-if="!loadingUsuariosModal && todosLosUsuariosGrupo.length > 0">
              Total: {{ todosLosUsuariosGrupo.length }} usuario(s)
            </span>
          </div>

          <!-- Lista de usuarios con infinite scroll -->
          <div 
            class="usuarios-scroll-container"
            @scroll="handleScrollUsuarios"
            ref="scrollContainerUsuarios"
          >
            <!-- Lista simple de usuarios -->
            <div v-if="usuariosGrupo.length > 0">
              <div
                v-for="(usuario, index) in usuariosGrupo"
                :key="index"
                class="usuario-list-item"
              >
                {{ usuario.usuario }}
              </div>
              
              <!-- Indicador de carga al final -->
              <div v-if="loadingUsuariosModal" class="text-center py-3">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="30"
                ></v-progress-circular>
                <p class="mt-2 text-caption">Cargando más usuarios...</p>
              </div>
              
              <!-- Mensaje cuando no hay más datos -->
              <div v-if="!loadingUsuariosModal && !hayMasUsuarios" class="text-center py-3 text-caption text-grey">
                <v-icon size="small">mdi-check-circle</v-icon>
                No hay más usuarios para mostrar
              </div>
            </div>

            <!-- Loading inicial -->
            <div v-else-if="loadingUsuariosModal" class="text-center py-8">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2 text-caption">Cargando usuarios...</p>
            </div>

            <!-- Sin usuarios -->
            <div v-else class="text-center py-8">
              <v-icon size="64" color="grey">mdi-account-off</v-icon>
              <p class="text-body-2 text-grey mt-2">No hay usuarios en este grupo</p>
            </div>
          </div>

          <!-- Contador de usuarios mostrados -->
          <div v-if="usuariosGrupo.length > 0" class="text-center mt-2 text-caption text-grey">
            Mostrando registros del 1 al {{ usuariosGrupo.length }} de un total de {{ todosLosUsuariosGrupo.length }} registros
          </div>
        </v-card-text>

        <v-card-actions class="px-4 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            color="#ce501b"
            variant="elevated"
            @click="cerrarModalUsuarios"
            size="small"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue'
import axios from '@/plugins/axios'
import Swal from 'sweetalert2'

const grupos = ref([])
const loading = ref(false)
const hayMasDatos = ref(true)
const paginaActual = ref(1)
const itemsPorPagina = ref(20)
const scrollContainer = ref(null)
const busqueda = ref('')
const dialogNuevoGrupo = ref(false)
const dialogVerUsuarios = ref(false)
const todosLosGrupos = ref([])
const guardando = ref(false)
const validFormNuevo = ref(false)
const formNuevoGrupo = ref(null)
const modoEdicion = ref(false)
const grupoEditando = ref(null)
const grupoSeleccionado = ref(null)

// Variables para el selector de jefe de grupo
const usuariosDisponibles = ref([])
const loadingUsuarios = ref(false)

// Variables para usuarios del grupo en modal Ver Usuarios
const usuariosGrupo = ref([])
const todosLosUsuariosGrupo = ref([])
const loadingUsuariosModal = ref(false)
const hayMasUsuarios = ref(true)
const paginaActualUsuarios = ref(1)
const itemsPorPaginaUsuarios = ref(15)
const scrollContainerUsuarios = ref(null)

const campoBusquedaRef = ref(null)

// Datos del nuevo grupo
const nuevoGrupo = ref({
  grupo: '',
  idJefe: null
})

onMounted(async () => {
  await cargarGrupos()
  document.addEventListener('keydown', handleKeyboardGlobal)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyboardGlobal)
})


const campoGrupoRef = ref(null)



const cargarGrupos = async () => {
  if (loading.value || !hayMasDatos.value) return
  
  loading.value = true
  
  try {
    if (todosLosGrupos.value.length === 0) {
      const response = await axios.get('/api/Grupos/list-grupo')
      
      if (response.data.success) {
        todosLosGrupos.value = response.data.data
        //console.log('Grupos cargados:', todosLosGrupos.value.length)    //Usarlo solo para ver los errores en el testeo de Software
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudieron cargar los grupos',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        })
        return
      }
    }
    
    const inicio = (paginaActual.value - 1) * itemsPorPagina.value
    const fin = inicio + itemsPorPagina.value
    const itemsPaginados = todosLosGrupos.value.slice(inicio, fin)
    
    if (itemsPaginados.length > 0) {
      grupos.value = [...grupos.value, ...itemsPaginados]
      paginaActual.value++
    }
    
    if (fin >= todosLosGrupos.value.length) {
      hayMasDatos.value = false
    }
    
  } catch (error) {
    //console.error('Error al cargar grupos:', error)     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los grupos',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
      }
    })
  } finally {
    loading.value = false
  }
}

// Cargar usuarios disponibles para el selector
const cargarUsuariosDisponibles = async (idGrupo = null) => {
  loadingUsuarios.value = true
  
  try {
    // ✅ Si hay idGrupo, agregarlo a la URL
    let url = '/api/Users/list-por-grupo'
    if (idGrupo) {
      url += `?idGrupo=${idGrupo}`
    }
    
    const response = await axios.get(url)
    
    if (response.data.success) {
      usuariosDisponibles.value = response.data.data.map(u => ({
        idUsuario: u.idUsuario,
        usuario: u.usuario
      }))
      //console.log('✅ Usuarios cargados para selector:', usuariosDisponibles.value.length)        //Usarlo solo para ver los errores en el testeo de Software
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudieron cargar los usuarios',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }
  } catch (error) {
    //console.error('Error al cargar usuarios:', error)        //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los usuarios',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    })
  } finally {
    loadingUsuarios.value = false
  }
}

const handleScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target
  if (scrollTop + clientHeight >= scrollHeight * 0.8) {
    cargarGrupos()
  }
}

const recargarDesdeInicio = () => {
  grupos.value = []
  todosLosGrupos.value = []
  paginaActual.value = 1
  hayMasDatos.value = true
  cargarGrupos()
}

const gruposFiltrados = computed(() => {
  if (!busqueda.value) {
    return grupos.value
  }
  
  const termino = busqueda.value.toLowerCase()
  return grupos.value.filter(grupo => 
    grupo.idGrupo?.toLowerCase().includes(termino) ||
    grupo.grupo?.toLowerCase().includes(termino)
  )
})

const filtrarGrupos = () => {
  // Filtrado automático con computed
}

const abrirModalNuevoGrupo = async () => {
  modoEdicion.value = false
  limpiarFormulario()
  await cargarUsuariosDisponibles()
  dialogNuevoGrupo.value = true
  nextTick(() => {
    setTimeout(() => {
      const input = campoGrupoRef.value?.$el?.querySelector('input')
      if (input) input.focus()
    }, 100)
  })
}

const editarGrupo = async (grupo) => {
  //console.log('Editar grupo:', grupo)    //Usarlo solo para ver los errores en el testeo de Software
  modoEdicion.value = true
  grupoEditando.value = grupo
  
  try {
    // ✅ Cargar usuarios del grupo específico
    await cargarUsuariosDisponibles(grupo.idGrupo)
    
    // Cargar detalle del grupo
    const response = await axios.get(`/api/Grupos/detalle/${grupo.idGrupo}`)
    
    if (response.data.success) {
      const detalle = response.data.data
      //console.log('Detalle del grupo:', detalle)   //Usarlo solo para ver los errores en el testeo de Software
      
      // ✅ Si tiene jefe, agregarlo temporalmente a la lista si no existe
      if (detalle.idJefeGrupo && detalle.usuarioJefe) {
        const jefeExiste = usuariosDisponibles.value.find(
          u => u.idUsuario === detalle.idJefeGrupo
        )
        
        if (!jefeExiste) {
          usuariosDisponibles.value.unshift({
            idUsuario: detalle.idJefeGrupo,
            usuario: detalle.usuarioJefe
          })
          //console.log('✅ Jefe agregado a la lista:', detalle.usuarioJefe)    //Usarlo solo para ver los errores en el testeo de Software
        }
      }
      
      // Asignar valores
      nuevoGrupo.value = {
        grupo: detalle.usuario,
        idJefe: detalle.idJefeGrupo || null
      }
      
      await nextTick()
      
      //console.log('✅ Grupo cargado:', nuevoGrupo.value)   //Usarlo solo para ver los errores en el testeo de Software
      
      dialogNuevoGrupo.value = true
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo cargar el grupo',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      })
    }
  } catch (error) {
    //console.error('Error al cargar detalle del grupo:', error)     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar el grupo',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    })
  }
}

const guardarGrupo = async () => {
  const { valid } = await formNuevoGrupo.value.validate()
  
  if (!valid) {
    return
  }

  guardando.value = true

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    
    if (!idUsuarioSesion) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      })
      guardando.value = false
      return
    }

    if (modoEdicion.value) {
      // ========================================
      // MODO EDICIÓN - Actualizar grupo
      // ========================================
      const payload = {
        id: grupoEditando.value.idGrupo,
        usuario: nuevoGrupo.value.grupo,
        idJefe: nuevoGrupo.value.idJefe || ""
      }

      //console.log('Actualizando grupo:', payload)      //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.put(
        `/api/Grupos/actualizar-grupo?idUsuarioSesion=${idUsuarioSesion}`,
        payload
      )

      if (response.data.success) {
        cerrarModal()
        
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Éxito!',
          text: 'Grupo actualizado correctamente',
          confirmButtonColor: '#ce501b',
          cancelButtonColor: '#9B9B9B',
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            cancelButton: 'swal-btn-cancelar', 
            container: 'swal-sobre-modal'
          },
          timer: 2500,
          showConfirmButton: true
        })

        recargarDesdeInicio()
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo actualizar el grupo',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        })
      }
    } else {
      // ========================================
      // MODO NUEVO - Crear grupo
      // ========================================
      const payload = {
        usuario: nuevoGrupo.value.grupo,
        idJefe: nuevoGrupo.value.idJefe || ""
      }

      //console.log('Creando grupo:', payload)     //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.post(
        `/api/Grupos/registrar-grupo?idUsuarioSesion=${idUsuarioSesion}`,
        payload
      )

      if (response.data.success) {
        cerrarModal()
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          iconColor: '#ce501b',
          text: 'Grupo registrado correctamente',
          confirmButtonColor: '#ce501b',
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            container: 'swal-sobre-modal'
          },
          timer: 2500,
          showConfirmButton: true
        })

        recargarDesdeInicio()
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo registrar el grupo',
          customClass: {
           title: 'swal-title-custom',
           container: 'swal-sobre-modal'
         }
        })
      }
    }
  } catch (error) {
    //console.error('Error al guardar grupo:', error)    //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al guardar el grupo',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    })
  } finally {
    guardando.value = false
  }
}

const limpiarFormulario = () => {
  nuevoGrupo.value = {
    grupo: '',
    idJefe: null
  }
  if (formNuevoGrupo.value) {
    formNuevoGrupo.value.reset()
  }
}

const cerrarModal = () => {
  dialogNuevoGrupo.value = false
  modoEdicion.value = false
  grupoEditando.value = null
  limpiarFormulario()
}

// Método verUsuarios actualizado
const verUsuarios = async (grupo) => {
  //console.log('Ver usuarios del grupo:', grupo)   //Usarlo solo para ver los errores en el testeo de Software
  grupoSeleccionado.value = grupo
  dialogVerUsuarios.value = true
  
  // Resetear estado
  usuariosGrupo.value = []
  todosLosUsuariosGrupo.value = []
  paginaActualUsuarios.value = 1
  hayMasUsuarios.value = true
  
  await cargarUsuariosGrupo(grupo.idGrupo)
}

// Método para cargar usuarios del grupo (modal Ver Usuarios)
const cargarUsuariosGrupo = async (idGrupo) => {
  if (loadingUsuariosModal.value || !hayMasUsuarios.value) return
  
  loadingUsuariosModal.value = true
  
  try {
    if (todosLosUsuariosGrupo.value.length === 0) {
      const idUsuarioSesion = localStorage.getItem('idUsuario')
      
      if (!idUsuarioSesion) {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: 'No se pudo obtener la información del usuario en sesión',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        })
        loadingUsuariosModal.value = false
        return
      }

      const response = await axios.get(
        `/api/Grupos/usuarios/${idGrupo}?idUsuarioSesion=${idUsuarioSesion}`
      )

      if (response.data.success) {
        todosLosUsuariosGrupo.value = response.data.data
        //console.log('Usuarios del grupo cargados:', todosLosUsuariosGrupo.value.length)    //Usarlo solo para ver los errores en el testeo de Software
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudieron cargar los usuarios',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        })
        loadingUsuariosModal.value = false
        return
      }
    }
    
    const inicio = (paginaActualUsuarios.value - 1) * itemsPorPaginaUsuarios.value
    const fin = inicio + itemsPorPaginaUsuarios.value
    const itemsPaginados = todosLosUsuariosGrupo.value.slice(inicio, fin)
    
    if (itemsPaginados.length > 0) {
      usuariosGrupo.value = [...usuariosGrupo.value, ...itemsPaginados]
      paginaActualUsuarios.value++
    }
    
    if (fin >= todosLosUsuariosGrupo.value.length) {
      hayMasUsuarios.value = false
    }
    
  } catch (error) {
    //console.error('Error al cargar usuarios del grupo:', error)      //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los usuarios del grupo',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    })
  } finally {
    loadingUsuariosModal.value = false
  }
}

const handleScrollUsuarios = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target
  
  if (scrollTop + clientHeight >= scrollHeight * 0.8) {
    cargarUsuariosGrupo(grupoSeleccionado.value?.idGrupo)
  }
}

const cerrarModalUsuarios = () => {
  dialogVerUsuarios.value = false
  grupoSeleccionado.value = null
  usuariosGrupo.value = []
  todosLosUsuariosGrupo.value = []
  paginaActualUsuarios.value = 1
  hayMasUsuarios.value = true
}

const confirmarEliminar = async (grupo) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `¿Deseas eliminar el grupo "${grupo.grupo}"?`,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    confirmButtonText: 'Sí, eliminar',
    customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar',
          cancelButton: 'swal-btn-cancelar'
        },
    cancelButtonText: 'Cancelar'
  })

  if (result.isConfirmed) {
    eliminarGrupo(grupo)
  }
}

const eliminarGrupo = async (grupo) => {
  //console.log('Eliminar grupo:', grupo)     //Usarlo solo para ver los errores en el testeo de Software
  
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    
    if (!idUsuarioSesion) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      })
      return
    }

    const response = await axios.delete(
      `/api/Grupos/eliminar-grupo/${grupo.idGrupo}?idUsuarioSesion=${idUsuarioSesion}`
    )

    if (response.data.success) {
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Eliminado!',
        text: `El grupo "${grupo.grupo}" ha sido eliminado exitosamente.`,
        confirmButtonColor: '#ce501b',
        cancelButtonColor: '#9B9B9B',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          cancelButton: 'swal-btn-cancelar',
          container: 'swal-sobre-modal'
        },
        timer: 2500,
        showConfirmButton: true
      })

      recargarDesdeInicio()
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        iconColor: '#ce501b',
        confirmButtonColor: '#ce501b',
         customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        },
        text: response.data.mensaje || 'No se pudo eliminar el grupo'
      })
    }
  } catch (error) {
    //console.error('Error al eliminar grupo:', error)     //Usarlo solo para ver los errores en el testeo de Software
    
    if (error.response?.status === 400) {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'No se puede eliminar',
        confirmButtonColor: '#ce501b',
         customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        },
        text: error.response?.data?.mensaje || 'El grupo tiene usuarios asociados',
      })
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'Hubo un problema al eliminar el grupo',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }
  }
}


const handleKeyboardGlobal = (event) => {

   // Alt + G → guardar/actualizar grupo desde cualquier campo del modal
  if (event.altKey && event.code === 'KeyG') {
    event.preventDefault()
    if (dialogNuevoGrupo.value) {
      guardarGrupo()
    }
  }

   // Alt + N → abrir modal Nuevo Grupo
  if (event.altKey && event.code === 'KeyN') {
    event.preventDefault()
    if (!dialogNuevoGrupo.value && !dialogVerUsuarios.value) {
      abrirModalNuevoGrupo()
    }
  }

  // Alt + B → enfocar buscador
  if (event.altKey && event.code === 'KeyB') {
    event.preventDefault()
    if (!dialogNuevoGrupo.value && !dialogVerUsuarios.value) {
      const input = campoBusquedaRef.value?.$el?.querySelector('input')
      if (input) input.focus()
    }
  }

  // ESC → cerrar modal si está abierto
  if (event.key === 'Escape') {
    if (dialogNuevoGrupo.value) {
      event.preventDefault()
      cerrarModal()
    }
    if (dialogVerUsuarios.value) {
      event.preventDefault()
      cerrarModalUsuarios()
    }
  }
}


</script>

<style scoped>
.grupos-container {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  padding-right: 8px;
}

.grupos-container::-webkit-scrollbar {
  width: 8px;
}

.grupos-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.grupos-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.grupos-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.grupos-table {
  background-color: transparent;
}

.grupos-table th {
  background-color: #def2ff !important;
  font-weight: bold !important;
  color: #37495f !important;
  white-space: nowrap;
}

.grupo-row {
  transition: background-color 0.2s ease;
}

.grupo-row:hover {
  background-color: rgba(59, 130, 200, 0.05);
}

.grupos-table td {
  padding: 12px 16px !important;
}

/* Campos amarillos */
:deep(.campo-amarillo .v-field) {
  background-color: #FFFACD !important;
}

/* Estilos para el modal de usuarios */
.usuarios-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
}

.usuarios-scroll-container::-webkit-scrollbar {
  width: 8px;
}

.usuarios-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.usuarios-scroll-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.usuarios-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.usuario-list-item {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: white;
  transition: background-color 0.2s ease;
  font-size: 14px;
  color: #333;
}

.usuario-list-item:hover {
  background-color: #f5f5f5;
}

.usuario-list-item:last-child {
  border-bottom: none;
}

.usuario-list-item:nth-child(even) {
  background-color: #fafafa;
}

.usuario-list-item:nth-child(even):hover {
  background-color: #f0f0f0;
}
</style>


<style>

.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

</style>

<style>
.swal-sobre-modal {
  z-index: 10000 !important;
}
</style>